type RoutePath = {
  title: string;
  path: string;
  slug: string;
  superadmin?: boolean;
};

export const routesPath: RoutePath[] = [
  {
    title: "Operational Map",
    path: "/operational-map",
    slug: "operational_map",
  },
  {
    title: "World Search",
    path: "/world-search",
    slug: "world_search",
  },
  {
    title: "Trips",
    path: "/trips",
    slug: "trips",
  },
  {
    title: "Sites",
    path: "/sites",
    slug: "sites",
  },
  {
    title: "Risk",
    path: "/risk/country-profiles",
    slug: "risk",
  },
  {
    title: "Reporting",
    path: "/reporting/summary",
    slug: "reports",
  },
  {
    title: "Siren",
    path: "siren/alerts?subPage=log",
    slug: "siren",
  },
  {
    title: "eLearning",
    path: "https://ngstravelsafety.elearning247.com/",
    slug: "e_learning",
  },
  {
    title: "Partners",
    path: "/partners",
    slug: "partners",
    superadmin: true,
  },
];
